import { render, staticRenderFns } from "./GameConfiguration.vue?vue&type=template&id=1f074fe2&"
import script from "./GameConfiguration.vue?vue&type=script&lang=js&"
export * from "./GameConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./GameConfiguration.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports